import { useContext } from 'react';

import { PerformanceMetricsContext } from './PerformanceMetricsContext-2';

export const usePerformanceMetrics = (): PerformanceMetricsContext => {
	return useContext(PerformanceMetricsContext);
};
